import React from "react";
import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import ImageSliderGrades from "./imagesslide";
import CommonImageSlider from "./comandata";
import { acadmicImages } from "./data";
import CallandRegisterComponent from "./Callbutton";
import SeoMeta from "./seometa";
import AdmissionForm from "./Admisssionsform";
import { Link, useNavigate } from "react-router-dom";



const seopages = {
    title: "Academics at Rankridge | CBSE & State Board Excellence",
    description:
      "Explore CBSE & State Board academics at Rankridge Hyderabad, designed for strong foundations and competitive exam success.",
    keywords: " rankridge academics, cbse academics hyderabad, state board academics hyderabad, rankridge curriculum, rankridge academic excellence, best cbse syllabus school hyderabad, best state syllabus school hyderabad, academic programs rankridge, rankridge competitive exam preparation, iit jee foundation academics, neet foundation academics, rankridge academic performance, school academic achievements hyderabad, rankridge learning approach, cbse board results hyderabad, state board results hyderabad, rankridge education methods, best academic school hyderabad, academic syllabus rankridge, school academics with competitive edge",
    canonical_path: "https://rankridgeschools.com/academics",
    og_description: "",
    og_image: "",
  };


const programs = [
  {
    title: "Rankridge Alpha Edge",
    subtitle: "Early Academic Achievers (Pre-School)",
    description:
      "Rankridge is the best Pre Schools near Kukatpally in Hyderabad. Nurturing Bright Beginnings through Playful Learning, Welcome to Rankridge AlphaEdge, a thoughtfully designed Pre-School Program that lays the foundation for a child’s lifelong love for learning. Tailored for children aged 2.5 to 5 years, our curriculum blends creative play, emotional well-being, and cognitive development to give your child the perfect start.",
    tag: "Pre-School Program",
  },
  {
    title: "Rankridge Excel Edge",
    subtitle: "Grades 1 to 5",
    description:
      "Where Curiosity Begins and Confidence Grows, at Rankridge is the best International Schools in Hyderabad, our ExcelEdge Program for Grades 1 to 5 is designed to lay a strong academic and emotional foundation for lifelong success. We blend the rigor of core subjects with creative expression, 21st-century skills, and experiential learning, ensuring that every child grows into a confident, curious, and capable learner. So Rankridge is the best Primary Schools Near Kukatpally in Hyderabad",
    tag: "Primary School Program",
  },
  {
    title: "Rankridge Pinnacle Edge",
    subtitle: "Grades 6 to 10 (IIT-JEE & NEET Foundation)",
    description:
      "Start Early, Aim Higher, Achieve More at Rankridge International School, our IIT-JEE and NEET Foundation Program is designed for students from Grades 6 to 10, setting the stage for exceptional success in India’s most competitive entrance exams. The Best Schools for IIT-JEE Coaching in Hyderabad as well as The Best schools for NEET Coaching in Hyderabad We blend academic mastery with real-world problem-solving skills to build a rock-solid foundation for engineering and medical aspirants. Rankridge is one and only School Provides IIT Foundation as well as NEET Foundation From Class 6th to 10th",
    tag: "Middle to Secondary School Program",
  },
  {
    title: "Rankridge Quantum - Elite Edge",
    subtitle: "Grades 11 to 12",
    description:
      "Personalized Learning, Global Outcomes, Infinite Possibilities, Rankridge Quantum EliteEdge is the pinnacle of Rankridge’s academic journey — a future-focused program for Grades 11 and 12 that provides elite-level preparation for IIT-JEE, NEET, SAT, CUET and Top Global Universities. With customized academic paths across CBSE, ICSE, State, and Cambridge (IGCSE/AS & A Levels), we empower students to conquer national and international goals with confidence.",
    tag: "Board + Competitive Coaching",
  },
];


export default function AcademicPrograms(props) {
  const navigate=useNavigate()
  return (<div className=" ms-0 me-0">
      <h2  className="text-xl text-center text-black font-extrabold mt-10 mb-4 me-2 ms-2">Cultivating Tomorrow’s Leaders Through Academic Excellence & Innovation.</h2>
<div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-start ">
 <CommonImageSlider images={acadmicImages}/>
{props?.status==true?
 <div>
     <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-tight  text-center">About Rankridgeschools</h2>
 <p className="mt-4 m-4">Rankridge Schools is among the best schools in Hyderabad, offering a complete academic journey from Pre-School to Grade 12 with IIT-JEE and NEET Foundation programs. We are recognized as the best pre-schools near Kukatpally, the best primary schools in Hyderabad, and one of the top international schools in Hyderabad with CBSE, ICSE, State Board, and Cambridge (IGCSE/AS & A Levels) curriculum options. Our integrated approach from Class 6 onwards makes us one of the best schools in Hyderabad for both IIT Foundation and NEET coaching. We also rank among the best junior colleges in Hyderabad for IIT-JEE & NEET, helping students achieve national and global academic goals. Parents looking for quality education, competitive exam preparation, and holistic development trust Rankridge as their preferred choice
<Link to="/about-us" className="mt-3 font-roboto m-auto  text-[#20b2aa] px-1 py-2 rounded-lg font-semibold hover:bg-gray-200 transition">Read More</Link>

</p>
</div>:
<div>
     <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-tight  text-center">Academics That Go Beyond Text Books</h2>
 <p className="mt-4 m-4">At Rankridge Schools, learning is more than just academics · it’s about helping every child grow with confidence, curiosity, and care. From Pre-School to Grade 12, we provide a complete journey where children are encouraged to explore, question, and achieve their best. Families can choose from CBSE, ICSE, State Board, or Cambridge (IGCSE/AS & A Levels) · ensuring every student has the right path for their future.From Grade 6, our programs include early support for IIT-JEE and NEET, giving students the advantage of a strong foundation without added stress. In the senior years, we combine board preparation with focused mentoring so that each child is guided personally. With dedicated teachers, modern labs, and a caring environment, Rankridge prepares students not just for exams · but for life.
{/* <Link to="/about-us" className="mt-3 font-roboto m-auto  text-[#20b2aa] px-1 py-2 rounded-lg font-semibold hover:bg-gray-200 transition">Read More</Link> */}

</p>
</div>}
{/* <AdmissionForm /> */}
</div>


 <div className="mb-10 mt-8 me-2 ms-2">
<CallandRegisterComponent />
</div>
    <div className="min-h-screen py-1 px-1 bg-[#20b2aa] text-black">
      <motion.h1
        className="text-4xl font-extrabold text-center mb-4"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
       Rankridge Outstanding Academic Programs
      </motion.h1>

      <div className="grid gap-1 md:grid-cols-2 max-w-7xl mx-auto">
        {programs.map((program, index) => (
          <motion.div
            key={index}
            className="bg-white text-green-900 rounded-2xl p-6 shadow-xl hover:scale-[1.02] transition-transform duration-300"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <p className="text-sm font-semibold mb-2 uppercase tracking-wide text-[black]">
              {program.tag}
            </p>
                        <h4 className="text-md italic mb-3 text-[black]">{program.subtitle}</h4>

            <h3 className="text-xl font-bold mb-1">{program.title}</h3>
            <p className="text-base leading-relaxed text-black">{program.description}</p>
          </motion.div>
        ))}
      </div>
    </div>

            <SeoMeta seopages={seopages} />

    </div>
  );
}
